module.exports = __webpack_public_path__ + "img/rima-rifai.0be4a314.jpg";